import { Link } from "gatsby";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import PopUp from "../components/popUp";
import Modal from "react-bootstrap/Modal";

export default function Levelup({ handleShow }) {
  return (
    <>
      <section className="tekrevol__levelup p-100 overflow-x-hidden">
        <Container>
          <Row>
            <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
              <div
                className="example example-bottom center text-center"
                data-text="Level Up"
              >
                <h2>Level Up Your Digital Ecosystem</h2>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
              <div className="serv-item">
                <div className="serv-inner h-100 tekrevol_gray_bg">
                  <div className="content">
                    <h3 className="title">
                      Strategic Guidance <br className="d-xl-block d-none" />
                      for Product Development
                    </h3>
                    <div className="sub-title">Fractional CPO</div>
                    <p>
                      Leverage our experienced Chief Product Officer to refine
                      your product <br className="d-xxl-block d-none" />
                      strategy and steer your team towards success.
                    </p>
                  </div>
                  {/* <a href="javasccript:void();" aria-label="Strategic Guidance for Product Development" className="btn-pri" onClick={handleShow}>
                                    Get Product Insights
                                </a> */}
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
              <div className="serv-item">
                <div className="serv-inner h-100 tekrevol_gray_bg">
                  <div className="content">
                    <h3 className="title">
                      Technical Expertise <br className="d-xl-block d-none" />
                      on Demand
                    </h3>
                    <div className="sub-title">Fractional CTO</div>
                    <p>
                      Benefit from the expertise of our Fractional Chief
                      Technology Officer to{" "}
                      <br className="d-xxl-block d-none" />
                      navigate complex technical challenges and drive innovation
                      in your projects.
                    </p>
                  </div>
                  {/* <Link to="/" aria-label="WP-Pals" className="btn-pri">
                                    Get Product Insights
                                </Link> */}
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-4">
              <div className="serv-item">
                <div className="serv-inner h-100 tekrevol_gray_bg">
                  <div className="content">
                    <h3 className="title">
                      Marketing Leadership <br className="d-xl-block d-none" />
                      at Your Fingertips
                    </h3>
                    <div className="sub-title">Fractional CMO</div>
                    <p>
                      Enhance your marketing efforts with our Fractional Chief
                      Marketing <br className="d-xxl-block d-none" />
                      Officer, guiding your brand strategy and maximizing your
                      market reach.
                    </p>
                  </div>
                  {/* <Link to="/" aria-label="WP-Pals" className="btn-pri">
                                    Get Product Insights
                                </Link> */}
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-0">
              <div className="serv-item">
                <div className="serv-inner h-100 tekrevol_gray_bg">
                  <div className="content">
                    <h3 className="title">
                      Executive Leadership <br className="d-xl-block d-none" />
                      Support
                    </h3>
                    <div className="sub-title">Fractional CEO</div>
                    <p>
                      Access seasoned leadership with our Fractional Chief
                      Executive Officer, <br className="d-xxl-block d-none" />
                      providing strategic direction and fostering growth for
                      your business.
                    </p>
                  </div>
                  {/* <Link to="/" aria-label="WP-Pals" className="btn-pri">
                                    Get Product Insights
                                </Link> */}
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="mt-auto mb-auto"
            >
              <div className="btn-wrap text-center">
                <span className="btn-pri" onClick={handleShow}>
                  Consult Our Experts
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <Modal
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className='modal-popup'
        >
            <div className="modal_forms">
            <PopUp setShow={setShow} />
            </div>
        </Modal> */}
    </>
  );
}
